export var UNSET_VALUE = '-';
export var AMPLITUDE_PREFIX = 'AMP';
export var STORAGE_PREFIX = "".concat(AMPLITUDE_PREFIX, "_unsent");
export var AMPLITUDE_SERVER_URL = 'https://api2.amplitude.com/2/httpapi';
export var EU_AMPLITUDE_SERVER_URL = 'https://api.eu.amplitude.com/2/httpapi';
export var AMPLITUDE_BATCH_SERVER_URL = 'https://api2.amplitude.com/batch';
export var EU_AMPLITUDE_BATCH_SERVER_URL = 'https://api.eu.amplitude.com/batch';
//# sourceMappingURL=constants.js.map